import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { Pagination } from '../../quipli-service/pagination/pagination';
import { handleCustomerPaginatedRequest, handleCustomerRequest } from '../customer-api-client';
import { SearchPaymentRequest } from '../../quipli-service/payment/payment';
import { CustomerInvoiceParsers } from '../invoice/customer-invoice-parsers';
import { CreatePaymentRequest } from '../../quipli-service/payment/payment-v2';
import { CustomerPayment } from '../invoice/customer-invoice';

export const useCustomerPaymentApiV2 = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  async function searchPayments(request: SearchPaymentRequest): Promise<Pagination<CustomerPayment>> {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/customer-api/v2/payments/search`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
    };
    const { items, pagination } = await handleCustomerPaginatedRequest<CustomerInvoiceParsers.CustomerPaymentJson>(
      config,
    );
    return { items: items.map(CustomerInvoiceParsers.toCustomerPayment), pagination };
  }

  async function createPayment(request: CreatePaymentRequest): Promise<CustomerPayment> {
    const config = {
      method: 'post',
      url: `${contextPath}quipli-service/customer-api/v2/payments`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
    };
    const result = await handleCustomerRequest<CustomerInvoiceParsers.CustomerPaymentJson>(config);
    return CustomerInvoiceParsers.toCustomerPayment(result);
  }

  return { searchPayments, createPayment };
};
